module.exports = __webpack_public_path__ + "static/media/ico_reports_overview.dc446471.svg";